import { Helper } from '@hems/util';
import { LANGUAGE, localStorageKey } from '@hems/util/src/constant';
const defaultLangCd = localStorage.getItem(localStorageKey.language);
function getLocale() {
    const lang = localStorage.getItem(localStorageKey.language);
    if (Helper.getEnvLocale() === 'AU' && lang === 'en') {
        return 'en-AU';
    }
    return localStorage.getItem(localStorageKey.language) || 'en';
}
const isLanguageValue = (value) => value === LANGUAGE.EN ||
    value === LANGUAGE.DE ||
    value === LANGUAGE.FR ||
    value === LANGUAGE.KO ||
    value === LANGUAGE.PT;
// cookie로 부터 선택된 locale 정보를 가져오고 없으면
// DB에 저장된 Locale 정보 가져오고
// 그것도 없으면 영어로 default 선택
export const initState = {
    langCd: isLanguageValue(defaultLangCd) ? defaultLangCd : 'en',
    envLocale: Helper.getEnvLocale(),
    termsVer: process.env[`VUE_APP_TERMS_VER_${Helper.getEnvLocale()}`] ?? '',
    curNav: [],
    scroll: null,
    locale: getLocale(),
    timeZone: '',
    googleApiKey: null,
    theme: 'light',
};
export default {
    namespaced: true,
    state: initState,
    mutations: {
        setLangCd(state, payload) {
            localStorage.setItem(localStorageKey.language, payload);
            state.langCd = payload;
        },
        setScroll(state, payload) {
            state.scroll = payload;
        },
        setLocale(state) {
            state.locale = getLocale();
        },
        setTimeZone(state, payload) {
            state.timeZone = payload;
        },
        setTermsVer(state, payload) {
            state.termsVer = payload;
        },
        setGoogleApiKey(state, payload) {
            state.googleApiKey = payload;
        },
        setTheme(state, payload) {
            state.theme = payload;
        },
    },
    actions: {
        setLangCd({ commit }, payload) {
            commit('setLangCd', payload);
        },
        setScroll({ commit }, payload) {
            commit('setScroll', payload);
        },
        setLocale({ commit }, payload) {
            commit('setLocale', payload);
        },
        setTimeZone({ commit }, payload) {
            commit('setTimeZone', payload);
        },
        setTermsVer({ commit }, payload) {
            commit('setTermsVer', payload);
        },
        setGoogleApiKey({ commit }, payload) {
            commit('setGoogleApiKey', payload);
        },
        setTheme({ commit }, payload) {
            commit('setTheme', payload);
        },
    },
};
